import React from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const ImporterModalAccountMenu = ({
  importer,
  handleDisconnect,
}) => {
  const intl = useIntl();

  if (
    !importer ||
    !importer.connected ||
    !importer.account ||
    Object.keys(importer.account).length === 0
  ) {
    return null;
  }

  return (
    <UncontrolledDropdown className="modal-import-account-menu">
      <DropdownToggle tag="a">
        {importer.account.avatar_url ? (
          <div className="user-avatar">
            <img className="avatar avatar-30" src={importer.account.avatar_url} alt="" />
          </div>
        ) : (
          <div className="avatar avatar-30 icon-avatar user-avatar gray">
            <i className="fas fa-user" />
          </div>
        )}
        {importer.account.name ? (
          <span>{importer.account.name}</span>
        ) : (
          <span>{importer.account.email}</span>
        )}
        <i className="far fa-chevron-down" />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem onClick={handleDisconnect}>
          {intl.formatMessage({ defaultMessage: 'Disconnect account' })}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

ImporterModalAccountMenu.propTypes = {
  importer: PropTypes.object,
  handleDisconnect: PropTypes.func.isRequired,
};

ImporterModalAccountMenu.defaultProps = {
  importer: null,
};

export default ImporterModalAccountMenu;
